import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_price, format_date } from '../../functions/functions_formatting.js';


export default class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            orders: [],
        };
    }


    componentDidMount() {
        this.updateData();
    }


    componentDidUpdate() {
        this.updateData();
    }


    updateData() {
        if (this.props.orders != this.state.orders) {
            // Update state
            this.setState({
                orders: this.props.orders
            });
        }
    }


    render() {

        return (
            <div className="account__section">
                <div className="account__element account__element__orderlist">
                    {/* <div className="account__element__orderlist__label">
                        Order ID
                    </div> */}
                    <div className="account__element__orderlist__label">
                        Date
                    </div>
                    <div className="account__element__orderlist__label">
                        Trip
                    </div>
                    <div className="account__element__orderlist__label">
                        Seller
                    </div>
                    <div className="account__element__orderlist__label">
                        Price
                    </div>
                    <div className="account__element__orderlist__label">
                        Status
                    </div>

                    {(this.state.orders && this.state.orders.length >= 1) &&
                        this.state.orders.map((order, i) => (
                            <React.Fragment key={order.order_id}>
                                {/* <div className="account__element__orderlist__value">
                                    {order.order_id}
                                </div> */}
                                <div className="account__element__orderlist__value">
                                    {format_date(order.created, true, true)}
                                </div>
                                <Link to={"/trip/" + order.trip_id} className="account__element__orderlist__value">
                                    {order.label}
                                </Link>
                                {order.seller_username &&
                                    <Link to={"/u/" + order.seller_username} className="account__element__saleslist__value">
                                        {order.seller_username}
                                    </Link>
                                }
                                {!order.seller_username &&
                                    <div className="account__element__saleslist__value">
                                        Not available
                                    </div>
                                }
                                <div className="account__element__orderlist__value">
                                    {order.payment.amount_total_gross && format_price(parseFloat(order.payment.amount_total_gross))}
                                </div>
                                <div className="account__element__orderlist__value">
                                    {order.payment.status}
                                </div>
                            </React.Fragment>
                        ))
                    }

                    {!(this.state.orders && this.state.orders.length >= 1) &&
                        <div className="account__element__orderlist__value account__element__orderlist__value--all-columns">
                            No orders available
                        </div>
                    }

                </div>
            </div>
        )
    }
}